import { Routes, Route, Link } from "react-router-dom";
import { useContext, useEffect } from "react";

import { GlobalContext, Section } from "../lib/Root";
import Error404 from "../pages/Error404";

export default function About() {
	return <Routes>
		<Route index element={<AboutLocal />} />
		<Route path="/FAQ" element={<AboutFAQ />} />
		<Route path="/contact" element={<AboutContact />} />
		<Route path="/careers" element={<AboutCareers />} />
		<Route path="*" element={<Error404 />} />
	</Routes>
}

function AboutLocal() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "About Us"; }, []);

	return <Section center>
		<p>There isn't much to know about us...<br />We prefer it that way...</p>
	</Section>
}

function AboutFAQ() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Frequently Asked Questions"; }, []);

	return <Section center>
		<p>We prefer customers who don't ask a lot of questions...</p>
		<p>If you have serious questions, please <Link to="/about/contact">contact us</Link>.</p>
	</Section>
}

function AboutContact() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Contact Us"; }, []);

	return <Section center>
		<p>To contact us, please send an email to:</p>
		<Link to="mailto:postmaster@huskydevelopment.com">postmaster@huskydevelopment.com</Link>
	</Section>
}

function AboutCareers() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Careers"; }, []);

	return <Section center>
		<p>We are currently <b>not</b> hiring.</p>
	</Section>
}